import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateFilterPartial } from '../actions';
import { Alert } from '../components/atoms';
import { EventsFilter } from '../interfaces';
import { useFilter } from './useFilter';

export const useFilterInput = (field: keyof EventsFilter) => {
  const [value, setValue] = useState<string>('');
  const dispatch = useDispatch();
  const filter = useFilter();

  const handleCommaSeparatedIds = (commaSeparatedValue: string, transformFunction?: (name: string) => number | string) => {
    const idsToAdd: string[] = [];
    const invalidIds: string[] = [];

    // Split by comma and trim whitespace
    let ids = commaSeparatedValue
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id);

    if (transformFunction) {
      ids = ids.map((id) => String(transformFunction(id))).filter((id) => id);
    }

    ids.forEach((id) => {
      // Check if already selected
      if (filter[field]?.includes(id)) {
        return;
      }

      idsToAdd.push(id);
    });

    // Add all valid IDs
    if (idsToAdd.length > 0) {
      dispatch(
        updateFilterPartial({
          [field]: [...(filter[field] || []), ...idsToAdd],
        }),
      );
    }

    // Show feedback for invalid or already selected IDs
    if (invalidIds.length > 0) {
      new Alert(`Invalid IDs: ${invalidIds.join(', ')}`).alert();
    }

    // Clear the input field
    setValue('');
  };

  return [value, setValue, handleCommaSeparatedIds] as const;
};
